module.exports = __webpack_public_path__ + "static/media/plug.bbce0106.svg";